import { useEffect, useRef } from 'react';
import { trackScrollDepth, trackTimeOnPage } from '@/utils/analytics';

export const useScrollTracking = (pageName: string) => {
  const maxDepth = useRef(0);
  const startTime = useRef(0);

  useEffect(() => {
    maxDepth.current = 0;
    startTime.current = Date.now();

    const handleScroll = () => {
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0) return;
      const depth = Math.round((window.scrollY / scrollHeight) * 100);
      if (depth > maxDepth.current) {
        maxDepth.current = depth;
        if (depth % 25 === 0 && depth > 0) {
          trackScrollDepth(depth);
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      const seconds = Math.round((Date.now() - startTime.current) / 1000);
      if (seconds > 2) {
        trackTimeOnPage(pageName, seconds);
      }
    };
  }, [pageName]);
};
